const normalise = value => String(value).trim().toLowerCase();

const toValueSet = values => new Set((Array.isArray(values) ? values : values == null ? [] : [values]).map(normalise));

/**
 * Scores a participant against the recommended columns: matched columns / recommended columns.
 * A column matches when at least one recommended value equals one of the participant's values for it.
 * Column names and values are compared case-insensitive and trimmed.
 * @param {Object} categories Recommended values per column name
 * @param {Object} profileData Participant's values per column name
 * @return {number} Score between 0 and 1
 */
export function recommendedMatchScore(categories, profileData) {
    const columns = Object.keys(categories);

    if (!columns.length) return 0;

    const profileValues = {};
    for (const [column, values] of Object.entries(profileData)) {
        profileValues[normalise(column)] = toValueSet(values);
    }

    let matched = 0;
    for (const column of columns) {
        const participantValues = profileValues[normalise(column)];
        if (participantValues && [...toValueSet(categories[column])].some(value => participantValues.has(value))) {
            matched++;
        }
    }

    return matched / columns.length;
}
